import React, { ChangeEvent, useCallback, useEffect,  useState } from "react";
import { ImageUploadUtil } from "../../../APIs/index";
import {  Modal,  message } from "antd";

import ProductModal from "../../Modal/ProductModal/ProductModal";
import productServiceInstance, { Product } from "../../../APIs/product";
import ProductTable from "./ProductTable/ProductTable";
import HeaderTable from "../HeaderTable/HeaderTable";
import { useNotification } from "../../Toast/Notification";

const ManageProducts: React.FC = () => {
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [caption, setCaption] = useState<string>("");
  const [image, setImage] = useState<string>("");
  const [selectedRole, setSelectedRole] = useState("all");
  const { notify } = useNotification();
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 6;
  const [pageNumbers, setPageNumbers] = useState<number[]>([]);

  const [selectedAccessory, setSelectedAccessory] = useState<Product | null>(
    null
  );

  const [products, setProducts] = useState<Product[] >([]);
  const [isEditModal, setEditModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [accessorylink, setAccessoryLink] = useState("");
  const [meta_title, setMetaTitle] = useState("");
  const [meta_description, setMetaDescription] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [banner, setBanner] = useState<string>("");
  const [ingredient, setIngredient] = useState<string>("");
  const [productLinkName, setProductLinkName] = useState<string>("");
  const [price, setPrice] = useState<number>(0);

  const [loading, setLoading] = useState(false);
  const [productaltbanner, setProductaltbanner] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [product_type, setProductType] = useState<string>("");
  const [searchText, setSearchText] = useState<string>("");
  const [rating] = useState<number>(0);
  const [height, setHeight] = useState<string>("");
  const [width, setWidth] = useState<string>("");
  const [length, setLength] = useState<string>("");
  const [weight, setWeight] = useState<string>("");
  const [sku, setSku] = useState<string>("");
  const [shorten_name, setShorten_name] = useState("");


  const fetchData = async () => {
    try {
      const response = await productServiceInstance.getAllProducts();

      if (response.data) {
        setProducts(response.data);
        setFilteredProducts(response.data);
      } else {
        console.error("Error fetching acc:", response.error);
      }
    } catch (error) {
      console.error("Error fetching acc:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedRole]);


  const handleFormSubmit = async () => {
    setLoading(true);

    const ProductData: Product = {
      shorten_name: shorten_name,
      name: name,
      description: description,
      meta_title: meta_title,
      meta_description: meta_description,
      caption: caption,
      productaltbanner: productaltbanner,
      image: image,
      banner: banner,
      ingredient: ingredient,
      productlinkname: productLinkName,
      category: category,
      price: price,
      rating: rating,
      product_type: product_type,
      height: height,
      width: width,
      length: length,
      weight: weight,
      sku,
    };

    try {
      const response = await productServiceInstance.createProduct(
        ProductData
      );

      if (response.data) {
        fetchData();
      
        setSelectedAccessory(null);
        setEditModal(false);
        setIsModalVisible(false)

        notify("Product Created successfully", "success");
      } else {
        console.error("Error creating Product:", response.error);
      }
    } catch (error) {
      console.error("Error creating Product:", error);
    } finally {
      setLoading(false);
    }
  };



  const handleFileChangeImage = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const uploadedImage = await ImageUploadUtil.uploadImage(file);
        if (uploadedImage.data) {

          setImage(uploadedImage.data);
        } else {
          console.error("Error uploading image:", uploadedImage.error);
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  const handleFileChangeBanner = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const uploadedImage = await ImageUploadUtil.uploadImage(file);
        if (uploadedImage.data) {

          setBanner(uploadedImage.data);
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  const handleSaveEdit = async () => {
    setLoading(true);
    try {
      if (selectedAccessory && selectedAccessory.id) {
        const updatedAccData = {
          shorten_name: shorten_name,
          name: name,
          description: description,
          meta_description: meta_description,
          meta_title: meta_title,
          caption: caption,
          image: image,
          banner: banner,
          ingredient: ingredient,
          price: price,
          productlinkname: productLinkName,
          product_type: product_type,
          height: height,
          width: width,
          weight: weight,
          length: length,
          category,
          sku,
        };

        const response = await productServiceInstance.editProduct(
          selectedAccessory.id,
          updatedAccData
        );



        if (response.data) {
          fetchData();

          setSelectedAccessory(null);
          setEditModal(false);

          notify("Product updated successfully", "success");
        } else {
          console.error("Error updating Product:", response.error);
          message.error("Error updating Product:");
        }
      } else {
        console.error("Selected Product or Product id is undefined");
      }
    } catch (error) {
      console.error("Error updating accessory:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditProduct = (product: Product) => {
    if (product) {
      setSelectedAccessory(product);
      setShorten_name(product.shorten_name || "");
      setName(product.name);
      setDescription(product.description);
      setCaption(product.caption);
      setImage(product.image);
      setMetaTitle(product.meta_title);
      setMetaDescription(product.meta_description);
      setBanner(product.banner);
      setIngredient(product.ingredient);
      setProductType(product.product_type);
      setPrice(product.price);
      setProductLinkName(product.productlinkname);
      setProductaltbanner(product.productaltbanner);
      setHeight(product.height || "");
      setWidth(product.width || "");
      setWeight(product.weight || "");
      setLength(product.length || "");
      setEditModal(true);
      setIsUpdating(true);
      setCategory(product.category);
      setSku(product.sku || "");
      setIsModalVisible(true);
      setIsUpdating(true);
    }
  };

  const handleAddProductClick = () => {
    setIsModalVisible(true);
    setIsUpdating(false);
    // setIsAdding(true);
  };

  const handleModalCancel = () => {
    setShorten_name("");  
    setIsModalVisible(false);
    setImage("");
    setEditModal(false);
    setImage("");
    setSelectedAccessory(null);
    setName("");
    setDescription("");
    setCaption("");
    setImage("");
    setMetaTitle("");
    setMetaDescription("");
    setBanner("");
    setIngredient("");
    setProductType("");
    setPrice(0);
    setProductLinkName("");
    setProductaltbanner("");
    setHeight('');
    setWidth("");
    setWeight("");
    setLength("");
    setSku("");

    setCategory("");
  };

  const handleModalEditCancel = () => {
    setEditModal(false);
    setShorten_name("");
    setImage("");
    setSelectedAccessory(null);
    setName("");
    setDescription("");
    setCaption("");
    setImage("");
    setMetaTitle("");
    setMetaDescription("");
    setBanner("");
    setIngredient("");
    setProductType("");
    setPrice(0);
    setProductLinkName("");
    setProductaltbanner("");
    setHeight("");
    setWidth("");
    setWeight("");
    setLength("");
    setEditModal(true);
    setIsUpdating(true);
    setCategory("");
    setSku("");
  };

  const handleDeleteAcc = async (productId: number) => {
    Modal.confirm({
      title: "Are you sure you want to delete this item?",
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        if (productId) {
          try {
            const { data, error } = await productServiceInstance.deleteProduct(
              productId
            );

            if (data) {

          
              notify("Product deleted successfully", "success");
              fetchData();
              setIsModalVisible(false);
              setSelectedAccessory(null);
            } else {
              console.error("Error deleting product:", error);
            }
          } catch (error) {
            console.error("Error deleting product:", error);
          }
        }
      },
    });
  };

  const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);
  const filterProductsFromSearch = useCallback((currentProducts: Product[]) => {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
  
    const tempProducts = currentProducts.filter((product) => {
      const productProperties = Object.values(product).map((value) =>
        String(value).toLowerCase()
      );
      return (
        (selectedRole === "all" || product.product_type === selectedRole) &&
        productProperties.some((property) =>
          property.includes(lowerCaseSearchTerm)
        )
      );
    });
  
    setFilteredProducts(tempProducts);
    setCurrentPage(1);
  }, [searchTerm, selectedRole, setFilteredProducts, setCurrentPage]);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterProductsFromSearch(products);
    } else {
      setFilteredProducts(products);
    }
  }, [searchTerm, products, filterProductsFromSearch]);

  useEffect(() => {
    filterProductsFromSearch(products);
  }, [searchTerm, selectedRole, products, filterProductsFromSearch]);

  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  const generatePageNumbers = useCallback(() => {
    const numbers = [];
    for (let i = 1; i <= totalPages; i++) {
      numbers.push(i);
    }
    setPageNumbers(numbers);
  }, [totalPages, setPageNumbers]);

  useEffect(() => {
    generatePageNumbers();
  }, [generatePageNumbers, totalPages]);

  const handleSearchTermChange = (e: any) => {
    setSearchTerm(e.target.value);
  };

  const handleRoleChange = (event: any) => {
    setSelectedRole(event.target.value);
  };

  return (
    <div className="p-6">
      <div className="hidden sm:block  py-2">
        <p
          className="mb-[15px] box-border font-semibold 
            text-[rgb(0,34,56)] block text-[35px] text-left h-auto
            leading-[38.4px]">
          Products
        </p>
        <div className="bg-white p-4 rounded-md w-5/4 mx-auto">
          <HeaderTable
            subtitle="Manage Products"
            buttonText="Add New Product"
            inputPlaceholder="Search Product"
            selectPlaceholder="Filter By Product Type"
            loading={false}
            searchTerm={searchTerm}
            selectedValue={selectedRole}
            onButtonClick={handleAddProductClick}
            onSearchChange={handleSearchTermChange}
            onSelectChange={handleRoleChange}
            selectOptions={[
              { value: "flavour", label: "Flavours" },
              { value: "cylinders", label: "Cylinder" },
            ]}
          />
          
          <ProductTable
            products={filteredProducts}
            loading={loading}
            onEditOrder={handleEditProduct}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            pageNumbers={pageNumbers}
            currentProducts={currentProducts}
            handleDeleteAcc={handleDeleteAcc}
          />
        </div>
      </div>

      <ProductModal
        setName={setName}
        name={name}
        description={description}
        setDescription={setDescription}
        image={image}
        setImage={setImage}
        caption={caption}
        setCaption={setCaption}
        meta_description={meta_description}
        meta_title={meta_title}
        accessorylink={accessorylink}
        handleFormSubmit={handleFormSubmit}
        loading={loading}
        setAccessoryLink={setAccessoryLink}
        isModalVisible={isModalVisible}
        isProcessing={loading}
        handleModalCancel={handleModalCancel}
        handleFileChangeImage={handleFileChangeImage}
        visible={isModalVisible}
        onClose={handleModalCancel}
        setMetaDescription={setMetaDescription}
        setMetaTitle={setMetaTitle}
        isUpdating={isUpdating}
        handleSaveEdit={handleSaveEdit}
        isEditModal={isEditModal}
        handleFileChangeBanner={handleFileChangeBanner}
        price={price}
        setPrice={setPrice}
        setBanner={setBanner}
        banner={banner}
        setIngredient={setIngredient}
        ingredient={ingredient}
        setHeight={setHeight}
        height={height}
        setWidth={setWidth}
        width={width}
        setLength={setLength}
        length={length}
        setWeight={setWeight}
        weight={weight}
        setProductType={setProductType}
        product_type={product_type}
        productLinkName={productLinkName}
        setProductLinkName={setProductLinkName}
        handleModalEditCancel={handleModalEditCancel}
        searchText={searchText}
        setSearchText={setSearchText}
        category={category}
        setCategory={setCategory}
        setSku={setSku}
        sku={sku}
        shorten_name={shorten_name}
        setShorten_name={setShorten_name} 
      />
    </div>
  );
};

export default ManageProducts;
